module.exports = __webpack_public_path__ + "files/c8130005d8cdd3fc6a3ecd547b17582e.png";